// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Cxf components
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";

// layouts components
import Header from "layouts/pages/account/components/Header";

function BaseLayout({ children, headerProps, isOwner, avatar, hasNoBannerAndAvatar }) {
  return (
    <>
      <div style={{
        padding: hasNoBannerAndAvatar ? 0 : "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <Header
          {...headerProps}
          isOwner={isOwner}
          avatar={avatar}
          hasNoBannerAndAvatar={hasNoBannerAndAvatar}
        />
      </div>
      <DashboardLayout>
        <SoftBox>
          {children}
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

// Typechecking props for BaseLayout
BaseLayout.propTypes = {
  stickyNavbar: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default BaseLayout;
